import PubSubJs from 'pubsub-js';
import store from './store';

export default class PubSub {
    moduleName: string;
    constructor(moduleName: string) {
        this.moduleName = moduleName;
    }
    publishStateUpdate(eventData: Record<string, unknown>): void {
        store.dispatch({
            type: this.moduleName,
            payload: eventData,
        });
        return PubSubJs.publish(this.moduleName, eventData);
    }
    subscribeToStateUpdate(moduleName: string, cb): void {
        return PubSubJs.subscribe(moduleName, cb);
    }
    unsubscribeToStateUpdate(token: string): void {
        return PubSubJs.unsubscribe(token);
    }
}
